import { useState } from 'react'
import emailjs from 'emailjs-com'
import styled, { keyframes } from "styled-components";


const St1 = styled.section`
  width: 100%;
  min-height: 120px;
  padding: 80px 20px;
  background: radial-gradient(circle at top, #081a2f, #081a2f);
  direction: rtl;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 40px;

  /* 💻 טאבלט */
  @media (max-width: 768px) {
    padding: 60px 15px;
  }

  /* 📱 מובייל */
  @media (max-width: 480px) {
    padding: 40px 10px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

const Logo = styled.img`
  max-width: 250px;
  height: auto;
  display: block;
`;

const Text = styled.p`
  margin: 0;
  font-size: clamp(14px, 4vw, 16px);
  color: #fff;

  a {
    color: #fff;
    text-decoration: none;
    font-weight: 600;
  }
`;

export const Contact = (props) => {

  return (
<St1 style={{
    textAlign: "center",
    padding: "20px 10px",
    marginTop: "40px",
    width: "100%",
}}>
    <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "15px" // רווח בין התמונה לטקסט
    }}>
        
        {/* הוספת התמונה מתיקיית public */}
        <a href="https://siteb2b.co.il" target="_blank" rel="noopener noreferrer">
            <img 
                src="/logooo1.png"  // אם התמונה בתוך public/logo.png
                alt="Logo siteb2b" 
                style={{
                    maxWidth: "250px", // מגביל את רוחב התמונה
                    height: "auto",    // שומר על פרופורציות
                    display: "block"
                }} 
            />
        </a>

        <p style={{
            margin: 0,
            fontSize: "clamp(14px, 4vw, 16px)",
            color: "#ffffff"
        }}>
            &copy; {new Date().getFullYear()} SG1 | אתר זה נבנה על ידי{' '}
            <a 
                href="https://siteb2b.co.il" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: "#ffffff", textDecoration: "none", fontWeight: "600" }}
            >
                siteb2b.co.il
            </a>
        </p>
    </div>
</St1>
 
  
  )
}


